import {gql, type TypedDocumentNode} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import {useHeaderHeight} from '@react-navigation/elements';
import type {StackScreenProps} from '@react-navigation/stack';
import {observer} from 'mobx-react-lite';

import type {RootStackParamList} from '../../RootStack/RootStackParamList';
import ShowMeetingCardScreen from '../../screens/ShowMeetingCardScreen';
import {useTheme} from '../../styling';
import type {
  GetCardByIdQuery,
  GetCardByIdQueryVariables,
} from './ShowMeetingCardBinding.generated';

export type ShowMeetingCardBindingProps = StackScreenProps<
  RootStackParamList,
  'ShowMeetingCard'
>;

export default observer(function ShowMeetingCardBinding(
  props: ShowMeetingCardBindingProps,
) {
  const {route} = props;
  const {id: _id} = route.params ?? {};
  const id = parseInt(_id ?? '', 10);
  const {data: cardData} = useQuery(GET_CARD_BY_ID, {variables: {id}});
  const card = cardData?.Card;
  const theme = useTheme();
  const headerHeight = useHeaderHeight();
  return (
    <ShowMeetingCardScreen
      title={card ? card.title : 'Не найдено'}
      body={
        card ? card.body : `Не удалось найти карточку с идентификатором ${id}`
      }
      backgroundColor={card?.backgroundColor ?? theme.palette.background}
      textColor={card?.textColor ?? theme.palette.textPrimary}
      borderColor={card?.borderColor ?? theme.palette.textPrimary}
      compensateHeaderHeight={headerHeight}
    />
  );
});

const GET_CARD_BY_ID: TypedDocumentNode<
  GetCardByIdQuery,
  GetCardByIdQueryVariables
> = gql`
  query GetCardById($id: Int!) {
    Card(id: $id) {
      id
      title
      body
      backgroundColor
      textColor
      borderColor
    }
  }
`;
